/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/const',[], function() {
    'use strict';


    var CONST = {
        /**
         * for specifying different types of widgets/charts in pdf file
         * @type {Object}
         */
        TYPES: {
            CHART: 'chart',
            DASHBOARD: 'dashboard',
            ZONING: 'zoning'
        },
        /**
         * for specifying various time formats in PDF generation
         * @type {Object}
         */
        TIME_FORMAT: {
            PDF_GENERATION: 'MMM Do YYYY, h:mm A ([GMT] Z)',
            CUSTOM_DATE: 'MMM Do YYYY'
        },
        /**
         * for zoniong related constants
         * @type {Object}
         */
        ZONING: {
            UNITS: {
                METER: {
                    NAME: 'meter',
                    DIMENSIONS: 'sq. m.'
                },
                FEET: {
                    NAME: 'feet',
                    DIMENSIONS: 'sq. ft.'
                }
            }
        }
    };
    return CONST;
});
